import { useSearchParams } from "next/navigation";

export function useQueryParam<T>(param: string, defaultValue: T): T {
  const searchParams = useSearchParams()

  if (searchParams === null) {
    throw new Error('useQueryParam can only be used within the context of the app router');
  }

  if (searchParams.has(param)) {
    return searchParams.get(param) as T;
  }

  return defaultValue;
}
